/*
 * @Author: KellyYang
 * @Date: 2022-06-30 09:29:54
 * @LastEditors: KellyYang
 * @Description: 下载页面
 */
import React, { Fragment } from "react";
import { List } from "antd";
import phone from "@/assets/img/download-page/phone.png";
import logo from "@/assets/img/download-page/logo.png";
import appleBtn from "@/assets/img/download-page/appleBtn.png";
import androidBtn from "@/assets/img/download-page/androidBtn.png";
import "./index.less";

const DownLoad = () => {
  const listItem = [
    {
      img: logo,
      title: "智能小工具",
      script: "客户经理尽调小助手"
    }
  ]

  const onDownLoadApp = (type) => {
    switch (type) {
      case 'apple':
        console.log('apple');
        break;
      case 'android':
        console.log('android');
        break;
    }
  }
  return (
    <Fragment>
      <div className="download-container">
        <div className="main-container">
          <div className="phone-container">
            <img src={phone} alt="phone" />
          </div>
          <div className="content-container">
            <List
              itemLayout="horizontal"
              dataSource={listItem}
              renderItem={(item) => {
                return (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<img width="100px" height="100px" src={item.img} alt="icon" />}
                      title={<span>{item.title}</span>}
                      description={<span>{item.script}</span>}
                    />
                  </List.Item>
                );
              }}
            />
            <img className="img-btn" src={appleBtn} alt="appleBtn" onClick={() => {onDownLoadApp('apple')}}/>
            <img className="img-btn" src={androidBtn} alt="androidBtn" onClick={() => {onDownLoadApp('android')}}/>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default DownLoad;
